import { HttpEvent, HttpHandlerFn, HttpInterceptorFn, HttpRequest, HttpResponse } from '@angular/common/http';
import { Observable, of, tap } from 'rxjs';
import {
  clearStoredToken,
  decodeToken,
  getStoredToken,
  isTokenExpired,
  setStoredToken,
} from '../../helpers/token/token.helper';

const fileUrls = ['/admin/import/analyze-file', '/admin/import/profiles'];

export const accessTokenHandlerInterceptor: HttpInterceptorFn = (
  req: HttpRequest<unknown>,
  next: HttpHandlerFn,
): Observable<HttpEvent<unknown>> => {
  if (req.url.includes('/login')) {
    return next(req).pipe(
      tap((event) => {
        if (event instanceof HttpResponse) {
          const newToken = (event.body as { token: string }).token;
          setStoredToken(newToken);
        }
      }),
    );
  } else if (req.url.includes('/logout')) {
    clearStoredToken();

    return of(void 0);
  }

  const isLocalRequest = req.url.includes('assets');

  if (isLocalRequest) {
    return next(req);
  }

  const token = getStoredToken();

  if (!token) {
    return next(req);
  }

  const requestWithToken = req.clone({
    setHeaders: {
      Authorization: `Bearer ${token}`,
    },
  });

  const isFileUploadingRequest = fileUrls.some((url) => req.url.includes(url));

  const req$ = isFileUploadingRequest
    ? requestWithToken
    : requestWithToken.clone({
        setHeaders: {
          'Content-Type': 'application/json',
        },
      });

  return next(req$).pipe(
    tap((event) => {
      if (event instanceof HttpResponse) {
        const authHeaders = event.headers.get('Authorization');

        if (authHeaders) {
          const [type, token] = authHeaders.split(' ');

          if (type !== 'Bearer' || !token) {
            return;
          }

          const decodedToken = decodeToken(token);

          if (decodedToken && !isTokenExpired(decodedToken)) {
            setStoredToken(token);
          }
        }
      }
    }),
  );
};
